import React, { useContext, useEffect, useState } from "react";

const ThemeContext = React.createContext();

export function useTheme() {
  return useContext(ThemeContext);
}

export function AuthProvider({ children }) {
  const [spacing,setSpacing] = useState(0)
  const [loading, setLoading] = useState(false);
  const [fontSize, setFontSize] = useState(1);

  function enableCharacterSpacing(){
    if(spacing === 0){
      setSpacing(2)
    }else{
      setSpacing(0)
    }
  }
  function increaseFontSize() {
    if (fontSize < 2) {
      setFontSize((prev) => prev + 0.2);
    }
  }

  function decreaseFontSize() {
    if (fontSize > 0.6) {
      setFontSize((prev) => prev - 0.4);
    }
  }

  function defaultFontSize() {
    setFontSize(1);
  }
 
  const value = {
    fontSize,
    spacing,
    enableCharacterSpacing,
    increaseFontSize,
    decreaseFontSize,
    defaultFontSize,
  };

  return <ThemeContext.Provider value={value}>{!loading && children}</ThemeContext.Provider>;
}
